export default class Line {
  constructor(payload) {
    this.id = payload.id;
    this.name = payload.name;
    this.code = payload.code;
    this.organizationId = payload.organizationId;
    this.stations = payload.stations;
    this.updatedAt = payload.updatedAt;
  }
}
